import { useIntl } from 'react-intl';

import { FormProps } from '@calm-web/use-form';

import { useAnalytics } from '@/hooks/analytics/useAnalytics';

import { calculatingSelectedContractedLives } from '../../../utils';
import messages from './messages';
import { Container, LegalLink, TocCheckbox, TocText } from './styles';

const PaymentTermsAndConditions: React.FC<{
	formProps: FormProps<'isTocChecked'>;
	context: {
		location?: string;
		variant?: string;
		companySize?: string;
		selectedCoveredLives?: number;
	};
}> = ({ formProps, context: { location, variant, companySize, selectedCoveredLives } }) => {
	const { formatMessage } = useIntl();
	const { logEvent } = useAnalytics();

	const handleCheckboxChange = (isChecked: boolean): void => {
		logEvent('Teams : Checkout : Payment : Toc : Clicked', {
			isChecked,
			selectedCoveredLives: selectedCoveredLives ?? '',
			selectedContractedLives: calculatingSelectedContractedLives(selectedCoveredLives ?? 0),
			companySize: companySize ?? '',
			location: location ?? '',
			variant: variant ?? '',
		});
	};

	const checkboxProps = formProps.bindWithErrorProps('isTocChecked', 'checkbox', 'isTocChecked');
	const wrappedOnChange = (e: Parameters<typeof checkboxProps.onChange>[0]): void => {
		checkboxProps.onChange(e);
		handleCheckboxChange(e.target.checked);
	};

	return (
		<Container data-testid="payment-terms-and-conditions">
			<TocCheckbox
				data-testid="payment-terms-and-conditions-checkbox"
				{...checkboxProps}
				onChange={wrappedOnChange}
			>
				<TocText>
					{formatMessage(messages.body, {
						msalink: (...chunks: React.ReactNode[]) => (
							<LegalLink href="https://calm.com/master-services-agreement" target="_blank" rel="noreferrer">
								{chunks}
							</LegalLink>
						),
						dpalink: (...chunks: React.ReactNode[]) => (
							<LegalLink
								href="https://business.calm.com/data-processing-addendum/"
								target="_blank"
								rel="noreferrer"
							>
								{chunks}
							</LegalLink>
						),
						supportlink: (...chunks: React.ReactNode[]) => (
							<LegalLink
								href="https://support.calm.com/hc/en-us?solvvyProvidedByEmployer"
								target="_blank"
								rel="noreferrer"
							>
								{chunks}
							</LegalLink>
						),
					})}
				</TocText>
			</TocCheckbox>
		</Container>
	);
};

export default PaymentTermsAndConditions;
